import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/zastroishik"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6C14 4.4087 13.3679 2.88258 12.2426 1.75736C12.2157 1.73046 12.1886 1.70384 12.1613 1.6775L11.5 3H10V0.343143C9.36359 0.118125 8.68789 0 8 0C7.31211 0 6.63641 0.118125 6 0.343143V3H4.5L3.83875 1.6775C3.81139 1.70384 3.78426 1.73046 3.75736 1.75736C2.63214 2.88258 2 4.4087 2 6L1 6V8H15V6H14ZM8 14C6.86424 14 5.88691 13.4401 5.16435 12.5111C4.43337 11.5712 4 10.2901 4 9H2C2 10.7099 2.56663 12.4288 3.58565 13.7389C4.61309 15.0599 6.13576 16 8 16C9.86424 16 11.3869 15.0599 12.4144 13.7389C13.4334 12.4288 14 10.7099 14 9H12C12 10.2901 11.5666 11.5712 10.8356 12.5111C10.1131 13.4401 9.13576 14 8 14Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Zastroishik16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Zastroishik16 = createIcon(IconComponent);